const PREFIX = "Enrichment";
export const SET_SELECTED_MODEL_ID = `${PREFIX}_SET_SELECTED_MODEL_ID`;
export const SET_IS_PREVIEW_LOADING = `${PREFIX}_SET_IS_PREVIEW_LOADING`;
export const SET_ENRICHMENT_MODEL_LIST = `${PREFIX}_SET_ENRICHMENT_MODEL_LIST`;
export const SET_ENRICHMENT_CONTEXT_ID = `${PREFIX}_SET_ENRICHMENT_CONTEXT_ID`;
export const SET_PREVIOUS_DATASET_ENRICHMENT_MODELS = `${PREFIX}_SET_PREVIOUS_DATASET_ENRICHMENT_MODELS`;
export const SET_USER_SELECTED_PREVIEW_MODELS = `${PREFIX}_SET_USER_SELECTED_PREVIEW_MODELS`;
export const SET_ENRICHMENT_PREVIEW_DATA = `${PREFIX}_SET_ENRICHMENT_PREVIEW_DATA`;
export const SET_SHOW_ENRICHMENT_PROGRESS = `${PREFIX}_SET_SHOW_ENRICHMENT_PROGRESS`;
export const SET_ENRICHMENT_PROGRESS = `${PREFIX}_SET_ENRICHMENT_PROGRESS`;
export const SET_ENRICHMENT_STATUS = `${PREFIX}_SET_ENRICHMENT_STATUS`;
export const SET_ENRICHED_DATASET_ID = `${PREFIX}_SET_ENRICHED_DATASET_ID`;
export const SET_ENRICHED_TARGET_DATASET_ID = `${PREFIX}_SET_ENRICHED_TARGET_DATASET_ID`;
export const SET_MODEL_SELECTION_DATA = `${PREFIX}_SET_MODEL_SELECTION_DATA`;
export const SET_MODEL_PROMPT = `${PREFIX}_SET_MODEL_PROMPT`;
export const RESET_STORE = `${PREFIX}_RESET_STORE`;
